<template>
    <ion-tabs>

        <div class="scroll-y with-tabs custom-scrollbar">
            <transition name="fade" mode="out-in">
                 <router-view></router-view>
            </transition>
        </div>

        <!-- fix for active tabs -->
        <!--<ion-tab tab="tab-index"></ion-tab>
        <ion-tab tab="tab-pill"></ion-tab>
        <ion-tab tab="tab-questions"></ion-tab>-->

        <!-- tab nav bar -->
        <ion-tab-bar slot="bottom">
            <!--<ion-tab-button tab="tab-index">-->
                <router-link :to="{ name: 'KnowledgeScore' }" class="tab-router-link">
                    <svg class="tab-icon"><use xlink:href="#icon-scores"></use></svg>
                    <ion-label class="tab-text">Twój wynik</ion-label>
                </router-link>
            <!--</ion-tab-button>-->
            <!--<ion-tab-button tab="tab-pill">-->
                <router-link :to="{ name: 'KnowledgePill' }" class="tab-router-link">
                    <svg class="tab-icon"><use xlink:href="#icon-head"></use></svg>
                    <ion-label class="tab-text">Pigułki wiedzy</ion-label>
                </router-link>
            <!--</ion-tab-button>-->
            <!--<ion-tab-button tab="tab-questions">-->
                <router-link :to="{ name: 'KnowledgeQuestions' }" class="tab-router-link">
                    <svg class="tab-icon"><use xlink:href="#icon-questions"></use></svg>
                    <ion-label class="tab-text">Pytania</ion-label>
                </router-link>
            <!--</ion-tab-button>-->
        </ion-tab-bar>

    </ion-tabs>
</template>

<script>
    import Score from './tabs/Score'
    import KnowledgePill from "./tabs/KnowledgePill.vue";
    import Questions from "./tabs/Questions.vue";

    export default {
        name: 'KnowledgeIndex',
        components: {
            Questions,
            KnowledgePill,
            Score
        },
        data(){
            return{
                goingBack: false
            }
        },
        methods:{
            redirectToFirstTab(routeName){
                if(routeName == 'KnowledgeIndex'){
                    setTimeout(()=> {
                        this.$router.push({name: 'KnowledgeScore'})
                    }, 10)
                }
            },
        },
        created(){
            this.$root.$on('goingBack', (payload) => {
                this.goingBack = true;
            })
        },
        mounted(){
            this.redirectToFirstTab(this.$route.name);
        },
        beforeRouteUpdate (to, from, next) {
            // hotfix: swipe right redirect
            if(this.$route.name === "KnowledgeIndex" && this.goingBack === true){
                next({name: 'Index'})
            }else{
                this.redirectToFirstTab(to.name);
            }
            next();
        }
    }
</script>

<style lang="scss" scoped>
    //fix for hidden tabs container
    ion-tab {
        display: none !important;
    }
</style>
